import 'swiper/swiper-bundle.css'
import '../scss/widget-feed-instagram.scss'

import { Swiper, SwiperSlide } from "swiper/react"
import { Navigation, Autoplay } from "swiper/modules"
import type { InstagramApp } from '../instagram-app.props'
import { isDev } from '@/utils/enviroment-detector'

export function WidgetFeedInstagram({
    posts,
    urlInstagram,
    legenda = true,
    pathMidia = "",
    parameter = "",
    iconInstagram
}: Readonly<InstagramApp>) {
    if (!posts || posts.length === 0) return null

    // Extrai o @user do link do Instagram
    let userInsta: string | null = null
    if (urlInstagram) {
        try {
            const urlObj = new URL(urlInstagram)
            const path = urlObj.pathname.replace("/", "").split("/")[0]
            if (path) userInsta = path
        } catch {
            userInsta = null
        }
    }

    return (
        <div className="container">
            <div className="titulo-secao flex column align-center justify-center">
                <img
                    src={isDev() ? iconInstagram : 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='}
                    data-src={iconInstagram}
                    className="lazyload icon-instagram"
                    width="32"
                    height="32"
                    alt="Publicações no Instagram"
                    title="Publicações no Instagram"
                />
                <span className="descricao">Nos acompanhe no Instagram!</span>

                {urlInstagram && userInsta && (
                    <a
                        href={urlInstagram}
                        className="link-instagram"
                        target="_blank"
                        rel="nofollow noopener"
                    >
                        @{userInsta}
                    </a>
                )}
            </div>
            <Swiper
                modules={[Navigation, Autoplay]}
                navigation={{
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                }}
                autoplay={{
                    delay: 3500,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                }}
                breakpoints={{
                    280: { slidesPerView: 1.5 },
                    540: { slidesPerView: 2.5 },
                    700: { slidesPerView: 3, spaceBetween: 20 },
                    1024: { slidesPerView: 4 },
                }}
                rewind
                spaceBetween={30}
                className="instagram-carousel"
                id="feed"
            >
                {posts.map((post, idx) => {
                    const fileName =
                        post.media_type === "VIDEO"
                            ? post.thumbnail_file_name
                            : post.midia_file_name

                    if (!fileName) return null

                    return (
                        <SwiperSlide key={idx}>
                            <a
                                href={post.permalink}
                                className="link-instagram flex column center"
                                target="_blank"
                                rel="nofollow noopener"
                            >
                                <div className="midia">
                                    <img
                                        src={isDev() ? `${pathMidia}${fileName}${parameter}` : 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='}
                                        data-src={`${pathMidia}${fileName}${parameter}`}
                                        className="lazyload photo"
                                        alt="Instagram Post"
                                        width="240"
                                        height="285"
                                    />
                                </div>
                                <div className="post-caption">
                                    {legenda && post.caption && (
                                        <p className="caption">{post.caption}</p>
                                    )}
                                    <span className="cta-instagram">Ver no Instagram...</span>
                                </div>
                            </a>
                        </SwiperSlide>
                    )
                })}
                
                <div className="swiper-button-next"></div>
                <div className="swiper-button-prev"></div>
            </Swiper>
        </div>
    )
}